import { useMutation } from "urql";

import { UpdateCuAssignedDocument } from "../../../graphql/generated.ts";

export const useUpdateCUAssigned = () => useMutation(UpdateCuAssignedDocument);
